import { Component } from 'react';
import styled from 'styled-components';

import { fontSize } from '../../../../../common/css/setting/variable';
import { pcVisitedLink } from '../../../../../common/css/setting/mixin';
import { SportsItemStyle } from './sportsCommonStyle';

interface IProps {
  url: string;
  teamHome: string;
  teamVisitor: string;
  dataClParams: string;
}

const SoccerItem = styled.li`
  ${SportsItemStyle}
  padding: 4px 0;
  font-size: ${fontSize.px14};
`;

const SoccerLink = styled.a`
  ${pcVisitedLink}
`;

export default class SoccerGame extends Component<IProps> {
  /**
   *
   */
  public render() {
    return (
      <SoccerItem>
        <SoccerLink
          href={this.props.url}
          data-cl-params={this.props.dataClParams}
        >{`${this.props.teamHome} vs. ${this.props.teamVisitor}`}</SoccerLink>
      </SoccerItem>
    );
  }
}
